export const environment = {
  production: true,
  envPlaceholder: 'PROD',
  sentryDSN: 'https://b2cf6e0c5338defb3f40b1845ddfdd2f@o4508336415834112.ingest.de.sentry.io/4508476899590224',
  enableSentry: true,
};
